import type { MuxVideo } from '@bulknutrients/bulk-shared-lib/interfaces/Sanity';
import { Video } from '@components/Media/Video/Video';
import type { PortableTextTypeComponentProps } from '@portabletext/react';
import type { ReactElement } from 'react';

export function VimeoRenderer({
  videoId,
  altText,
}: {
  videoId: string;
  altText?: string;
}): ReactElement {
  return (
    <div className="relative isolate h-0 max-w-full overflow-hidden pb-[56.35%]">
      <iframe
        title={altText || ''}
        src={`https://player.vimeo.com/video/${videoId}`}
        width="640"
        height="360"
        style={{ border: '0px' }}
        allow="autoplay; fullscreen"
        allowFullScreen
        className="absolute left-0 top-0 h-full w-full"
      />
    </div>
  );
}

export function VimeoPortableTextRenderer(
  props: PortableTextTypeComponentProps<{
    _type: string;
    altText?: string;
    videoId: string;
  }>
): ReactElement {
  return (
    <VimeoRenderer
      videoId={props.value.videoId}
      altText={props.value.altText}
    />
  );
}

export function MuxPortableTextRenderer(
  props: PortableTextTypeComponentProps<MuxVideo>
): ReactElement {
  return (
    <Video
      playbackId={props.value.playbackId}
      altText={props.value.altText}
      placeholder={props.value.placeholder}
      aspectRatio={props.value.aspectRatio}
    />
  );
}
